import React, { useEffect, useState} from 'react';
import {IProps} from './types';
import * as S from './styles';
import { HexColorPicker, HexColorInput } from "react-colorful";
import EyeDropperIcon from '@assets/icons/eyeDropperIcon';
import EyeDropper from '@components/EyeDropper';

const ColorGenerator:React.FC<IProps> = (props) => {
  
  const [color, setColor] = useState(props.color??"FFFFFF");
  const [showEyeDropper, setShowEyeDropper] = useState(false);

  const startPickingColor = (e: React.MouseEvent<HTMLDivElement>) => {
    setShowEyeDropper(true);
  }

  const finishPickingColor = (selectedColor: string | undefined) => {
    setShowEyeDropper(false);
    if (selectedColor) {
      onColorChange(selectedColor);
      if (props.onEndChangeColor)
        props.onEndChangeColor();
    }
  }

  useEffect(()=>{    
    setColor(props.color??"FFFFFF")
  },[props.color])
  
  return (
    <S.Root>
      {
        showEyeDropper &&
        <EyeDropper
          selectColor={finishPickingColor}
        />
      }
      { props.show && 
        <>
          <HexColorPicker color={color} onChange={onColorChange} onClick={() => props.onEndChangeColor?props.onEndChangeColor():() =>{}} />
          <S.Bottom>
            <S.EyeDropperContainer
              onClick={startPickingColor}
            >
              <EyeDropperIcon
                pickedColor={color}
              />
            </S.EyeDropperContainer>
            { props.showInputText &&  
              <HexColorInput
                type="text"   
                color={color}
                onChange={onColorChange}
                onBlur={() => props.onEndChangeColor ? props.onEndChangeColor() : () =>{}} 
                prefixed={true}
                style={{
                  width: '100%',
                  boxSizing: 'border-box',
                  borderRadius: '2px',
                  margin: '0px',
                }}
              />
            }
          </S.Bottom>
        </>
      }
    </S.Root>
  )

  function onColorChange(e : any) {
    setColor(e);
    props.onChange(e);
  }
}

export default ColorGenerator;